module.exports = __webpack_public_path__ + "img/2008_S.f5d8aa40.png";